import { contains, filter } from 'ramda'

function groupFilter(groupList = []) {
  return filter(gr => contains(gr.name, groupList))
}

export { groupFilter }
